import { Box, Button, Flex, Heading, Text } from '@chakra-ui/react';
import { useQuery } from '@tanstack/react-query';
import { BrowserRouter, Link as RouterLink, Route, Routes, useLocation } from 'react-router-dom';
import { api } from './api';
import Overview from './pages/Overview';
import HostDetailPage from './pages/HostDetail';
import ManageHosts from './pages/ManageHosts';
import Metrics from './pages/Metrics';

const NAV_ITEMS = [
  { to: '/', label: 'Overview' },
  { to: '/metrics', label: 'Metrics' },
  { to: '/hosts', label: 'Manage hosts' },
];

function Header() {
  const location = useLocation();
  const { data } = useQuery({ queryKey: ['me'], queryFn: api.me, refetchInterval: false, retry: false });

  return (
    <Flex
      as='header'
      px={6}
      py={3}
      gap={6}
      align='center'
      borderBottomWidth='1px'
      borderColor='card.border'
      bg='card.bg'
    >
      <Heading size='md'>Site Manager</Heading>
      <Flex gap={4} flex={1}>
        {NAV_ITEMS.map(item => (
          <RouterLink key={item.to} to={item.to}>
            <Text
              fontWeight={location.pathname === item.to ? 'bold' : 'normal'}
              color={location.pathname === item.to ? 'primary.fg' : undefined}
            >
              {item.label}
            </Text>
          </RouterLink>
        ))}
      </Flex>
      {data?.user ? (
        <Flex gap={3} align='center'>
          <Text fontSize='sm' color='gray.500'>
            {data.user.email}
          </Text>
          <Button
            size='xs'
            variant='outline'
            onClick={() => {
              void api.logout().then(() => {
                window.location.href = '/auth/google';
              });
            }}
          >
            Sign out
          </Button>
        </Flex>
      ) : null}
    </Flex>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Flex direction='column' minH='100vh'>
        <Header />
        <Box as='main' flex={1} p={6}>
          <Routes>
            <Route path='/' element={<Overview />} />
            <Route path='/hosts' element={<ManageHosts />} />
            <Route path='/hosts/:name' element={<HostDetailPage />} />
            <Route path='/metrics' element={<Metrics />} />
          </Routes>
        </Box>
      </Flex>
    </BrowserRouter>
  );
}
